import React, { useContext } from 'react';
import { usePriceRowContext } from '../../../price-row-context';
import { MobileOnly } from 'src/ui/block';
import { IconChevronRight } from '@prisjakt/ui/icon';
import { AppContext } from '@prisjakt/ui-app-context';
import { ButtonIcon } from '@prisjakt/ui/button';
import { Button, StoreLink, LinkDesktop, LinkMobile, LinkText } from './styles';

type Props = {
  className?: string;
  isAlternative?: boolean;
};

export const GoToStoreButton: React.FC<React.PropsWithChildren<
  React.PropsWithChildren<Props>
>> = props => {
  const { className, isAlternative } = props;

  const { t } = useContext(AppContext);
  const {
    isOurChoice,
    newOfferItemExperiment,
    position,
  } = usePriceRowContext();

  const useSmallButton = isOurChoice && position === 'productHeader';

  return (
    <StoreLink className={className} data-test="GoToStoreButton">
      {/* Baseline and experiment on desktop */}
      <LinkDesktop
        ariaLabel={t('product', 'store.link')}
        tabIndex={-1}
        $useSmallButton={useSmallButton}
      >
        <LinkText $isOurChoice={useSmallButton}>
          {t('product', 'store.link')}
        </LinkText>
        <ButtonIcon>
          <IconChevronRight />
        </ButtonIcon>
      </LinkDesktop>

      {/* Experiment on mobile */}
      {newOfferItemExperiment && (
        <MobileOnly>
          <Button
            ariaLabel={t('product', 'store.link')}
            onlyIcon={isAlternative}
            tabIndex={-1}
          >
            {isAlternative ? (
              <ButtonIcon>
                <IconChevronRight />
              </ButtonIcon>
            ) : (
              <LinkText $isOurChoice={useSmallButton}>
                {t('product', 'store.link')}
              </LinkText>
            )}
          </Button>
        </MobileOnly>
      )}

      {/* Baseline on mobile */}
      {!newOfferItemExperiment && (
        <LinkMobile $useSmallButton={useSmallButton}>
          <IconChevronRight color="maybeBlue500" size={24} />
        </LinkMobile>
      )}
    </StoreLink>
  );
};
